import { render, staticRenderFns } from "./QRCardWithBtnComponent.vue?vue&type=template&id=310168be&"
import script from "./QRCardWithBtnComponent.vue?vue&type=script&lang=js&"
export * from "./QRCardWithBtnComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports